









































































import { snakeCase } from "lodash";
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import {
  BotProperty,
  PropertyFieldType
} from '../../../../../../../../../BotProperties/components/Properties/types'
import findPropertyById from '../../../../../../../logic/Helpers/findPropertyById'
import PropertyCondition, {
  PropertyConditionAction
} from '../../../logic/ConditionTypes/PropertyCondition'
import { SetPropertyActionValue } from '../../../logic/PropertyConditionValues/BaseValue'
import CalculateValue from '../../../logic/PropertyConditionValues/CalculateValue'
import ConstantValue from '../../../logic/PropertyConditionValues/ConstantValue'
import NowValue from '../../../logic/PropertyConditionValues/NowValue'
import PropertyValue from '../../../logic/PropertyConditionValues/PropertyValue'

@Component({
  data() {
    return {
      SetPropertyActionValue,
      PropertyValue,
      ConstantValue,
      CalculateValue,
    }
  }
})
export default class PropertyConditionView extends Vue {
  @Prop() condition!: PropertyCondition

  @Prop() properties!: Array<BotProperty>

  get isBooleanCondition(): boolean {
    return typeof this.leftProperty === 'object' && this.leftProperty?.type === PropertyFieldType.Flag
      && this.condition.action === PropertyConditionAction.Equals
      && (this.rightValue === 0 || this.rightValue === 1)
  }

  get leftProperty(): BotProperty | string | undefined {
    if (this.condition.left instanceof PropertyValue) {
      const property = findPropertyById(this.properties, this.condition.left.property_index)

      if (property) {
        return property
      }

      if (property === undefined && this.condition.left.property_index) {
        return this.$t('property_is_undefined').toString()
      }
    }

    return undefined
  }

  get rightProperty(): BotProperty | undefined {
    if (this.condition.right instanceof PropertyValue) {
      return findPropertyById(this.properties, this.condition.right.property_index)
    }

    return undefined
  }

  get conditionAction(): string {
    if (this.leftProperty && typeof this.leftProperty === 'object' && this.leftProperty.type === PropertyFieldType.Flag && this.condition.action === PropertyConditionAction.Equals) {
      if (this.condition.right instanceof PropertyValue) {
        return this.$t('new_condition_flag_prop_option').toString()
      } else if (this.condition.right instanceof ConstantValue) {
        if (this.condition.right.value === 0) {
          return this.$t('new_condition_false_option').toString()
        }
        return this.$t('new_condition_true_option').toString()
      }
    }

    return this.$t(`new_condition_${ snakeCase(this.condition.action) }_option`).toString()
  }

  get rightValue(): string | number | null {
    const right = this.condition.right

    if (right instanceof PropertyValue) {
      return this.rightProperty?.name ?? this.$t('property_not_found').toString()
    }

    if (right instanceof ConstantValue) {
      return right.value
    }

    if (right instanceof NowValue) {
      return this.$t('now_option').toString()
    }

    if (right instanceof CalculateValue) {
      return right.value
    }

    return null
  }
}
